import { useTranslation } from 'react-i18next';
import { usePageTools } from '../../components/page-header/page-tools';

/**
 * Shown while a route chunk loads (code splitting per route, ADR-003). It draws
 * the page header's frame (same title row height and margin as `PageHeader`)
 * so the real page replaces it without moving the content below. On a phone it
 * also carries the frame's tools (credits, search, bell; S150-8), which have no
 * top bar to live in there.
 */
export function RouteSkeleton() {
  const { t } = useTranslation();
  const tools = usePageTools();
  return (
    <div className="ui-stack">
      {/* Outside the status region: the tools are controls, not loading text. */}
      {tools ? (
        <div className="ui-page-head__top">
          <div className="ui-page-head__trail" />
          <div className="ui-page-head__tools">{tools}</div>
        </div>
      ) : null}
      <div role="status" className="ui-stack">
        <span className="ui-visually-hidden">{t('shell.loading')}</span>
        <div className="ui-page-head" aria-hidden="true">
          <div className="ui-page-header">
            <div className="ui-page-header__main">
              <div className="ui-page-header__titlerow">
                <div className="ui-skeleton ui-skeleton--title" />
              </div>
            </div>
          </div>
        </div>
        <div className="ui-skeleton ui-skeleton--card" aria-hidden="true" />
      </div>
    </div>
  );
}
